var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("administration.profile_add") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "pb-3 no-gutters" },
            [_c("back-button", { staticClass: "btnFilter_2" })],
            1
          ),
          _vm._v(" "),
          _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("administration.profile_info"),
                isTitleUpperCase: false,
              },
            },
            [
              _c("div", { staticClass: "form-group" }),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "ml-2 mr-2" },
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("administration.label"),
                          placeholderValue: _vm.$t("administration.label"),
                        },
                        model: {
                          value: _vm.libelle,
                          callback: function ($$v) {
                            _vm.libelle = $$v
                          },
                          expression: "libelle",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("administration.right"),
                isTitleUpperCase: false,
              },
            },
            [
              _c(
                "b-row",
                { staticClass: "ml-2 mr-2" },
                _vm._l(_vm.rights, function (result) {
                  return _c(
                    "b-col",
                    {
                      key: result,
                      staticClass: "form-group",
                      attrs: { sm: "4" },
                    },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          attrs: { value: result },
                          model: {
                            value: _vm.select_rights,
                            callback: function ($$v) {
                              _vm.select_rights = $$v
                            },
                            expression: "select_rights",
                          },
                        },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.$t("rights.db_rights." + result) ===
                                  "rights.db_rights." + result
                                  ? result
                                  : _vm.$t("rights.db_rights." + result)
                              ) +
                              "\n              "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            {
              staticClass:
                "accordionForm mt-3 justify-content-end form-group p-0 pr-2 no-gutters",
            },
            [
              _c(
                "b-button",
                {
                  staticClass: "btnFilter_2",
                  on: {
                    click: function ($event) {
                      return _vm.changeProfil()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa-light fa-save" }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }